import { ReactElement, useState, useRef, useEffect } from "react";
import "./PriceCard.scss";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { InfoCircleOutlined } from "@ant-design/icons";
type PriceCardProps = {
  title: string | ReactElement;
  headers: Array<string | ReactElement>;
  values: Array<string | ReactElement>;
  toggleInfoBox?: () => void;
  highlightBox?: boolean;
  setInfoBoxRef?: (ref: HTMLDivElement | null) => void;
  showMoreCount?: number;
  tooltipText?: string;
  staticInfoIcon?: boolean;
};

const PriceCard = ({ toggleInfoBox, ...props }: PriceCardProps) => {
  const [showAll, setShowAll] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!revealed) return;
    const handler = (e: MouseEvent) => {
      if (!cardRef.current?.contains(e.target as Node)) setRevealed(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [revealed]);

  return (
    <div
      className="trending-price-change-card"
      style={
        props.highlightBox
          ? { zIndex: 1000, boxShadow: "0 8px 30px rgba(0,0,0,0.2)" }
          : {}
      }
      ref={(ref) => {
        (cardRef as any).current = ref;
        props.setInfoBoxRef && props.setInfoBoxRef(ref);
      }}
    >
      {/* Arrow — always visible */}
      {props.tooltipText && (
        <span
          className={`arrowRight${revealed ? " arrowRight--open" : ""}`}
          style={props.staticInfoIcon ? { animation: 'none' } : undefined}
          onClick={() => setRevealed((p) => !p)}
        >
          <InfoCircleOutlined />
        </span>
      )}
      <h4 className="title">{props.title}</h4>
      {/* Sliding viewport — clips both panels, sized by front content */}
      <div className="sr-viewport">

        {/* Front — card content, slides left on reveal */}
        <div className={`sr-front${revealed ? " sr-front--out" : ""}`}>

          {props.values.length > 0 ? (
            <div className="price-table-container">
              <div
                className="price-grid"
                style={{
                  gridTemplateColumns: `repeat(${props.headers.length}, minmax(0,1fr))`,
                }}
              >
                {props.headers.map((header, i) => (
                  <div className="header" key={i}>{header}</div>
                ))}
                {props.values.map((value, i) => (
                  <div className="value" key={i}>{value}</div>
                ))}
              </div>
            </div>
          ) : (
            <div className="no-data">NO ALERTS !</div>
          )}
        </div>

        {/* Back — tooltip text, slides in from right */}
        {props.tooltipText && (
          <div className={`sr-back${revealed ? " sr-back--in" : ""}`}>
            <p className="sr-back-text">{props.tooltipText}</p>
          </div>
        )}

      </div>
    </div>
  );
};

export default PriceCard;